<template>
    <tr v-if="edit === true">
      <td>
        {{ index + 1 }}
      </td>
      <td>
        <input
          v-model="$v.date.$model"
          class="input"
          v-bind:class="{ 'is-danger': $v.date.$error }"
          type="datetime-local"
          placeholder="Date"
          step="1"
        >
      </td>

      <td>
        <div
          class="select is-fullwidth"
          v-bind:class="{'is-danger': $v.row.category_id.$error}"
        >
          <select
            v-model="$v.row.category_id.$model"
          >
            <option :value="null" selected="selected">Choose category</option>
            <option
              v-for="category in expenseCategories"
              :value="category.id"
              v-bind:key="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </td>

      <td>
        <input
          v-model="$v.row.name.$model"
          class="input"
          v-bind:class="{ 'is-danger': $v.row.name.$error }"
          type="text"
          placeholder="Name"
        >
      </td>
      <td>
        <input
          v-model="$v.row.total.$model"
          class="input"
          v-bind:class="{ 'is-danger': $v.row.total.$error }"
          type="number"
          placeholder="Price"
        >
      </td>
      <td>
        <div class="columns is-mobile">
          <div class="column has-text-centered">
            <font-awesome-icon icon="save" size="2x" @click="updateEntry" />
          </div>
          <div class="column has-text-centered">
            <font-awesome-icon icon="window-close" size="2x" @click="cancelEdit" />
          </div>
        </div>
      </td>
    </tr>
    <tr v-else>
      <td>{{ index + 1 }}</td>
      <td>{{ row.date }}</td>
      <td>{{ row.expense_category.name }}</td>
      <td>{{ row.name }}</td>
      <td>{{ row.total | price }}</td>
      <td>
        <div class="columns is-mobile">
          <div class="column has-text-centered">
            <font-awesome-icon icon="edit" size="2x" @click="edit = true"/>
          </div>
          <div class="column has-text-centered">
            <font-awesome-icon icon="trash-alt" size="2x" @click="deleteEntry" />
          </div>
        </div>
      </td>
    </tr>
</template>

<script>
import moment from 'moment';
import {
  required,
  decimal,
  integer,
} from 'vuelidate/lib/validators';
import EXPENSE_CATEGORIES from '@/graphql/expense-categories/expenseCategories.gql';
import DELETE_EXPENSE from '@/graphql/expenses/deleteExpense.gql';
import UPDATE_EXPENSE from '@/graphql/expenses/updateExpense.gql';

export default {
  name: 'ExpensesTableRow',
  props: [
    'initialRow',
    'index',
  ],
  data() {
    return {
      row: this.initialRow,
      expenseCategories: null,
      edit: false,
    };
  },
  computed: {
    date: {
      get() {
        return moment(this.row.date).format(moment.HTML5_FMT.DATETIME_LOCAL);
      },
      set(date) {
        this.row.date = moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
    },
  },
  validations: {
    row: {
      category_id: {
        required,
        integer,
      },
      name: {
        required,
      },
      total: {
        required,
        decimal,
      },
    },
    date: {
      required,
    },
  },
  apollo: {
    expenseCategories: EXPENSE_CATEGORIES,
  },

  methods: {
    updateEntry() {
      this.$apollo.mutate({
        mutation: UPDATE_EXPENSE,
        variables: {
          id: this.row.id,
          name: this.row.name,
          total: this.row.total,
          date: this.row.date,
          categoryId: this.row.category_id,
        },
      })
        .then((res) => {
          this.edit = false;
          this.row = res.data.updateExpense;
          this.$toasted.success('Entry updated');
          this.$emit('refetch-list');
        })
        .catch((err) => {
          this.$toasted.error(err);
        });
    },

    cancelEdit() {
      this.edit = false;
    },

    deleteEntry() {
      this.$root.$confirm.open(
        `Delete ${this.row.name}?`,
        "This action can't be reverted, are you sure?",
      ).then((confirm) => {
        if (confirm) {
          this.$apollo.mutate({
            mutation: DELETE_EXPENSE,
            variables: {
              id: this.row.id,
            },
          })
            .then(() => {
              this.$emit('refetch-list');
              this.$toasted.success('Entry deleted!');
            })
            .catch((error) => {
              this.$toasted.error(error);
            });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
